export default "__VITE_ASSET__BQtQFwuF__"